var TermService = /** @class */ (function () {
    function TermService(api) {
        this.API = api;
    }
    TermService.prototype.termLatest = function () {
        var url = '/term/latest';
        return this.API.get(url);
    };
    TermService.prototype.termLatestAccept = function (termId) {
        var url = '/term/latest/accept';
        var formData = {
            term_id: termId,
        };
        return this.API.post(url, formData);
    };
    TermService.prototype.termAll = function () {
        var url = '/term/all';
        return this.API.get(url);
    };
    return TermService;
}());
export { TermService };
